import { FadeUp } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

const chapters = [
  { num: "01.1", titleKey: "manifesto.c1.title", textKey: "manifesto.c1.text" },
  { num: "01.2", titleKey: "manifesto.c2.title", textKey: "manifesto.c2.text" },
  { num: "01.3", titleKey: "manifesto.c3.title", textKey: "manifesto.c3.text" },
];

export default function Manifesto() {
  const { t } = useLang();
  return (
    <section id="manifeste" data-testid="manifesto-section" className="relative px-6 md:px-12 py-28 md:py-40">
      <FadeUp className="flex items-baseline gap-4 mb-16 md:mb-24">
        <span className="font-mono-tech text-sm text-[#75FB4E]">(01)</span>
        <h2 className="font-display text-5xl md:text-8xl uppercase leading-none">{t("manifesto.section")}</h2>
      </FadeUp>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <FadeUp delay={0.1} className="md:col-span-5">
          <div className="relative overflow-hidden group">
            <img
              src="/images/portrait-chloe.webp"
              alt="Chloé Rigallaud-Leal, portrait"
              data-testid="manifesto-portrait"
              className="w-full aspect-[3/4] object-cover object-top group-hover:scale-105 transition-transform duration-700 ease-out"
            />
            <div className="absolute bottom-4 left-4 font-mono-tech text-[10px] tracking-widest text-[#E5E5E5]/80 bg-[#050505]/70 px-3 py-1">
              {t("manifesto.fig")}
            </div>
          </div>
        </FadeUp>

        <div className="md:col-span-6 md:col-start-7 flex flex-col gap-12">
          <FadeUp delay={0.15}>
            <p className="text-lg md:text-2xl font-light leading-relaxed text-[#E5E5E5]">
              {t("manifesto.intro")}
            </p>
          </FadeUp>
          {chapters.map((c, i) => (
            <FadeUp key={c.num} delay={0.1 + i * 0.08} className="border-t border-[#1A1A1A] pt-6 group">
              <div className="flex items-baseline gap-4 mb-3">
                <span className="font-mono-tech text-xs text-[#75FB4E]">{c.num}</span>
                <h3 className="font-display text-xl md:text-2xl uppercase group-hover:text-[#75FB4E] transition-colors duration-300">
                  {t(c.titleKey)}
                </h3>
              </div>
              <p className="text-sm md:text-base text-[#808080] leading-relaxed max-w-md">{t(c.textKey)}</p>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
